import { useState, useEffect } from "react";
import {
  getReportCustomerDue,
  getReportCustomerPayments,
  getReportCustomerStatus,
  getReportMonthlyPayments,
} from "../../api/finance";

export function useReportCustomerPayments({ filter }) {
  const [projects, setProjects] = useState([]);
  const [meta, setMeta] = useState({ total: 0 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getProjects = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getReportCustomerPayments({ ...filter });
      setProjects(data.data);
      setMeta(data.meta);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getProjects(filter);
  }, [filter]);

  return {
    projects,
    meta,
    loading,
    errorMsg,
    getProjects,
  };
}

export function useReportCustomerStatus({ filter }) {
  const [projects, setProjects] = useState([]);
  const [meta, setMeta] = useState({
    total_inactive: 0,
    total_active: 0,
    total_dismantled: 0,
    total_active_trial: 0,
    total_dismantled_trial: 0,
    total_deactivate_inactive: 0,
    total_reactivated: 0,
    total_homepass: 0,
    total_occupation_rate: "0%",
    total: 0,
  });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getProjects = async (filter) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getReportCustomerStatus(filter);
      setProjects(data.data);
      setMeta(data.meta);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getProjects(filter);
  }, [filter]);

  return {
    projects,
    meta,
    loading,
    errorMsg,
    getProjects,
  };
}

export function useReportCustomerDue({ filter }) {
  const [projects, setProjects] = useState([]);
  const [meta, setMeta] = useState({ total: 0 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getProjects = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getReportCustomerDue(filter);
      setProjects(data.data);
      setMeta(data.meta);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getProjects(filter);
  }, [filter]);

  return {
    projects,
    meta,
    loading,
    errorMsg,
    getProjects,
  };
}

export function useReportMonthlyPayments({ filter }) {
  const [reports, setReports] = useState([]);
  const [meta, setMeta] = useState({ total_revenue: 0 });
  const [pagination, setPagination] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getMontlyReport = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getReportMonthlyPayments(filter);
      setReports(data.data);
      setMeta(data.meta);
      setPagination(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getMontlyReport(filter);
  }, [filter]);

  return {
    reports,
    meta,
    pagination,
    loading,
    errorMsg,
    getMontlyReport,
  };
}
